import React from 'react'
import Profile from "../../../assets/Profile.png";
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const TeacherMsgCard = () => {
    const { t } = useTranslation();
    return (
        <div className="xl:mx-10 mx-0 ">
        <div className="flex flex-wrap items-center justify-between gap-7 mb-7">
          <div className="">
            <div>
              <img
                className="rounded-full border w-20 h-20"
                src={Profile}
                alt=""
              />
            </div>
            <div>
              <p className="font-semibold text-xl">{t("teacherDash.teacherMsgCard.sampleName")}</p>
            </div>
            <div className='flex space-x-10'>
            <p className="font-normal text-base">{t("teacherDash.teacherMsgCard.sampleClass")}</p>
            <p className="font-normal text-base">{t("teacherDash.teacherMsgCard.homeTutoring")}</p>
            </div>

          </div>
          <NavLink to ='./../mentor-chat'>
              <p className="bg-blue-500 rounded-lg text-white text-xl font-medium py-3 px-8">{t("teacherDash.teacherMsgCard.openChat")}</p>
          </NavLink>
        </div>
      </div>
      )
}

export default TeacherMsgCard
